import _defineProperty from "D:\\Portal_repos\\VE_R2.9\\SWIFMod_CC_Portal_11_4_1\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { JSON_CONTENT_TYPE, CONTENT_TYPE } from '../common';
export var jsonOptions = {
  headers: _defineProperty({}, CONTENT_TYPE, "".concat(JSON_CONTENT_TYPE, "; charset=UTF-8"))
};